import Colors from '../../../../styles/colors';

const styles = theme => ({
    root: {
        width: '100%',
        maxWidth: 700,
        display: 'inline-flex',
        marginTop: -10,
        [theme.breakpoints.down('md')]: {
            marginTop: 0,
        },
    },
    formControl: {
        transform: 'translate(0, 10px) scale(1)',
    },
    input: {
        ...theme.typography.h1,
        color: Colors.white,
        [theme.breakpoints.down('md')]: {},
    },
    labelShrink: {
        /* hide from vis, expose for screen readers */
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap', /* added line */
        width: 1,
    },
    disabled: {},
    underline: {
        '&:before, &:after': {
            borderBottom: `8px solid ${Colors.white}`,
        },
        '&:hover:not($disabled):before, &:hover:not($disabled):after': {
            borderBottom: `8px solid ${Colors.blue}`,
        },
        [theme.breakpoints.down('md')]: {
            '&:before, &:after': {
                borderBottom: `3px solid ${Colors.white}`,
            },
            '&:hover:not($disabled):before, &:hover:not($disabled):after': {
                borderBottom: `3px solid ${Colors.blue}`,
            },
        },
    },
    inputRoot: {
        paddingRight: '60px !important',
        marginTop: '-8px !important',
    },
    popupIndicator: {
        color: Colors.white,
        marginTop: -20,
        '& svg': {
            height: '3em',
            width: '3em',
            [theme.breakpoints.down('md')]: {
                height: '2em',
                width: '2em',
            },
        },
        [theme.breakpoints.down('md')]: {
            marginTop: -10,
        },
    },
    popupIndicatorOpen: {
        color: Colors.white,
        marginTop: -20,
        '& svg': {
            height: '3em',
            width: '3em',
            [theme.breakpoints.down('md')]: {
                height: '2em',
                width: '2em',
            },
        },
        [theme.breakpoints.down('md')]: {
            marginTop: -10,
        },
    },
    option: {
        '&:hover, &:focus': {
            backgroundColor: `rgba(${Colors.blueRGB}, .2)`,
        },
        '&[aria-selected="true"]': {
            backgroundColor: Colors.blue,
        },
        '&[data-focus="true"]': {
            backgroundColor: `rgba(${Colors.blueRGB}, .2)`,
        },
    },
});

export default styles;
